module.exports = __webpack_public_path__ + "img/logo_western_union3.b4806bc4.png";